import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import { ButtonEditInline } from 'Components/Buttons/ButtonEditInline'
import { DocumentationTableWrapper } from 'Components/Settings/Documentation/DocumentationTableWrapper'
import { DocumentationWrapper } from 'Components/Settings/Documentation/DocumentationWrapper'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { PageTitle } from 'Components/PageTitle'
import FilteredTable from 'Containers/FilteredTable'
import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'
import { getCountries } from 'Reducers/Countries/actions'
import { getDocumentTypes } from 'Reducers/Document/actions'
import { PATHS } from 'Config/Routing/paths'
import SettingsIcon from 'Assets/Images/icons/settings'
import SubmitButton from 'Components/Form/SubmitButton'
import { StatusLabel } from 'Components/StatusLabel'
import { authorization } from '../../../Module/Auth/Auth'
import { getCities } from '../../../Reducers/City/actions'
import StyledBreadcrumbs from '../../../Components/StyledBreadcrumbs'

class Documentation extends React.Component {
  constructor(props) {
    super(props)

    const user = authorization.getUser()
    const { countryCode } = user

    this.state = {
      countryCode,
      selectedCountries: [countryCode] || ['All'],
      documentAddModalShow: false,
      documentEditModalShow: false,
      documentationTableColumns: [
        {
          accessor: 'name',
          label: 'Name',
          name: 'name',
          sortable: true,
        },
        {
          accessor: 'instructionText',
          label: 'Instruction',
          name: 'instructionText',
          sortable: true,
        },
        {
          accessor: 'active',
          label: 'Status',
          name: 'status',
          sortable: true,
          render: active => {
            return <StatusLabel status={active ? 'active' : 'inactive'} />
          },
        },
        {
          accessor: 'countryCode',
          label: 'Country code',
          name: 'countryCode',
          sortable: true,
          render: value => (value ? value : 'ALL'),
        },
        {
          accessor: 'activeCities',
          label: '# of cities',
          name: 'activeCities',
          sortable: true,
          render: value => (value ? value : 'ALL'),
        },
        {
          type: 'actions',
          name: 'actions',
          label: 'Actions',
          accessor: 'id',
          render: id => (
            <div className="actions-cell">
              <ButtonEditInline
                onClickHandler={() => this.documentationEditHandler(id)}
              />
            </div>
          ),
        },
      ],
    }

    this.documentationEditHandler = this.documentationEditHandler.bind(this)
    this.getCountryFilterOptions = this.getCountryFilterOptions.bind(this)
    this.documentationAddHandler = this.documentationAddHandler.bind(this)
  }

  setSelectedCountries = newSelectedCountries => {
    this.setState({ selectedCountries: newSelectedCountries })
  }

  componentDidMount() {
    const { getCountries, getDocumentTypes, getCities } = this.props
    getCities()
    getCountries()
    getDocumentTypes()
  }

  render() {
    return (
      <DocumentationWrapper>
        <LayoutDashboard>
          {this.renderBreadcrumbs()}
          <PageTitle>Signup Identification Documents</PageTitle>
          <p style={{ marginBottom: '30px' }}>
            When signing up, users must take photographic evidence of each
            specified identification document for their application to be
            considered. Each country may have their own requirements.
          </p>
        </LayoutDashboard>
        {this.renderDocumentationTable()}
      </DocumentationWrapper>
    )
  }

  renderBreadcrumbs() {
    return (
      <div>
        <StyledBreadcrumbs
          icon={<SettingsIcon style={{ width: 20 }} />}
          breadcrumbs={[
            {
              label: 'Settings',
              link: `${PATHS.main.dashboard}${PATHS.dashboard.settings}`,
            },
            { label: 'Signup Identification Documents' },
          ]}
        />
      </div>
    )
  }

  renderDocumentationTable() {
    const { documentTypesList, citiesList } = this.props
    const { documentationTableColumns, selectedCountries } = this.state

    const documentTypesListWithoutOthersType = documentTypesList.filter(
      type => type.name !== 'Other',
    )
    const documentData = documentTypesListWithoutOthersType.map(document => {
      const allCitiesLength = citiesList.filter(
        city => city.country.code === document.countryCode,
      ).length
      const numberOfActiveCities =
        document.ignoredCities.length > 0
          ? (allCitiesLength - document.ignoredCities.length).toString()
          : !document.active
          ? '0'
          : 'All'
      return { ...document, activeCities: numberOfActiveCities }
    })

    const user = authorization.getUser()

    return (
      <DocumentationTableWrapper>
        <SubmitButton
          value="Add document"
          onClick={this.documentationAddHandler}
        />
        <br />
        <HideWhenBlocked>
          {documentTypesList && (
            <FilteredTable
              columns={documentationTableColumns}
              data={documentData.sort((a, b) => b.active - a.active)}
              filters={this.getFilters()}
              showSearchFilter={false}
              selectedCountries={selectedCountries}
              setSelectedCountries={this.setSelectedCountries}
              user={user}
            />
          )}
        </HideWhenBlocked>
      </DocumentationTableWrapper>
    )
  }

  documentationAddHandler() {
    const { history } = this.props

    history.push(`${this.props.match.url}/create`)
  }

  documentationEditHandler(id) {
    const { history } = this.props

    history.push(`${this.props.match.url}/${id}/edit`)
  }

  getCountryFilterOptions() {
    const { countries } = this.props

    return countries.map(country => country.code)
  }

  getFilters() {
    const filters = [
      {
        columnName: 'countryCode',
        label: 'Country',
        noValueLabel: 'All',
        options: this.getCountryFilterOptions(),
        sorted: true,
        value: this.state.selectedCountries,
      },
    ]

    return filters
  }
}

Documentation.propTypes = {
  countries: PropTypes.array.isRequired,
  documentTypesList: PropTypes.array.isRequired,
  getCountries: PropTypes.func.isRequired,
  getDocumentTypes: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  countries: state.countries.countriesList,
  documentTypesList: state.document.documentTypesList,
  citiesList: state.city.citiesList,
})

const mapDispatchToProps = dispatch => ({
  getCountries: () => dispatch(getCountries()),
  getCities: () => dispatch(getCities()),
  getDocumentTypes: () => dispatch(getDocumentTypes()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(Documentation))
